import { useEffect, useState } from "react";
import { webUrlNode } from "../../../../constants/appInfo";

export default function EmailUsageTable() {

  const [rows, setRows] = useState([]);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    const r = await fetch(
      `${webUrlNode}/api/email/usage?limit=50`
    );
    const j = await r.json();
    setRows(j);
  }

  return (
    <div>

      <h3>Usage</h3>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse"
        }}
      >
        <thead>
          <tr>
            <th>Date</th>
            <th>Email</th>
            <th>Use case</th>
            <th>Credits</th>
          </tr>
        </thead>

        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td>
                {new Date(r.createdAt).toLocaleString()}
              </td>
              <td>{r.toEmail}</td>
              <td>{r.useCase}</td>
              <td>{r.creditsUsed}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}
